// extracted by mini-css-extract-plugin
export default {"container":"Section4_container__oqWvd","topImage":"Section4_topImage__GUx1R","title":"Section4_title__2k5yd"};